var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormPart',{attrs:{"Item":_vm.Ticket,"setItemForm":_vm.setItemForm,"submitData":_vm.submitData},on:{"onSuccess":_vm.onSuccess,"onFail":_vm.onFail},scopedSlots:_vm._u([{key:"default",fn:function({
        errors,
        ItemForm,
        submit
      }){return [_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{attrs:{"error-messages":errors.maxPriceSpend,"filled":true,"dense":true,"hide-details":"auto","label":"Maximálna odpracovaná suma","type":"number","suffix":"€"},on:{"change":submit},model:{value:(ItemForm.maxPriceSpend),callback:function ($$v) {_vm.$set(ItemForm, "maxPriceSpend", $$v)},expression:"ItemForm.maxPriceSpend"}})],1)],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }